

export const environment = {
 host:{
  //apiurl:'https://test.idact-vps.ir/golestanService/index.php'
   apiurl:'https://golestankooh.com/backend/public',
     api_key:'cumjtobhwnhtormbdlbeixxhbduxmycv'
 }

};


